import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DtpContentContainer, DtpNoContent } from 'dtp-react-components';
import {
  Table,
  Button,
} from '../../components/index';
import ModalUploadDocumento from './Exigencia/ModalUploadDocumento';
import ModalEncerramentoExigencia from './Exigencia/ModalEncerramentoExigencia';
import ModalRejeicaoRequerimento from './Exigencia/ModalRejeicaoRequerimento';
import {
  buscaDestinatarios,
  doGet,
  trataMensagemSucesso,
  trataMensagensErro,
  doPut,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import * as constantes from '../../utils/constants';
import FiltroPesquisa from './FiltroPesquisa';
import ModalAlerta from '../../pages/requerimentos/ModalAlerta';

class ConsultaExigencia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaRequerimentosFiltrada: null,
      listaRequerimentosIndexada: [],
      requerimentoModalDocumento: {},
      requerimentoVindoDoRequest: null,
      tipoRequerimentoSelecionado: null,
      requerimentoModalExigencia: [],
      showDocumentUploadModal: false,
      showEncerramentoExigenciaModal: false,
      showRejeicaoRequerimentoModal: false,
      showNoContent: false,
      listaRequerimentosIndexadaAtualizada: false,
      showModalAlertaRequerPerConcomitancia: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosPesquisa: {},
      tipoRequerimento: null,
      requerimento: {},
      chaveConfirmacao: null,
    };
  }

  componentDidMount() {
    // manterApenasFiltro('filtroPesquisa');
    // if (this.props.match.params.tipoConsulta === 'analise') {
    //   manterApenasFiltro('');
    // }
    if (['analise', 'exigencia', 'prescricao-exigencia', 'complementar-aposentadoria', 'parecer-medico'].includes(this.props.match.params.tipoConsulta)
      && !sessionStorage.getItem('filtroPesquisa')) {
      this.realizaConsulta();
    } else {
      // eslint-disable-next-line
      if (this.props.destinatarios.length === 0) {
        buscaDestinatarios(this.tratarErro);
      }
    }
  }

  // shouldComponentUpdate(nextProps) {
  //   return nextProps.match.params.regime !== this.props.match.params.regime;
  // }

  componentDidUpdate(prevProps) {
    // if (this.props.match.params.tipoConsulta === 'exigencia' ||
    // this.props.match.params.tipoConsulta === 'prescricao-exigencia' ||
    // this.props.match.params.tipoConsulta === 'analise') {
    //   manterApenasFiltro('filtroPesquisa');
    // }
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.match.params.tipoConsulta !== prevProps.match.params.tipoConsulta
        || this.props.match.params.regime !== prevProps.match.params.regime) {
      this.preparaNovaConsulta();
    }
  }

  getTipoConsulta = () => (
    this.props.match.params.tipoConsulta
  )

  preparaNovaConsulta = () => {
    sessionStorage.removeItem('filtroPesquisa');
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaRequerimentosFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta);
  }

  lotacao = this.props.auth.userData.lotacoes[0];
  // .split(',')[0].split('#')[1];

  verificarSeFiltroPesquisaExiste = () => (
    (JSON.parse(sessionStorage.getItem('filtroPesquisa')) !== undefined && JSON.parse(sessionStorage.getItem('filtroPesquisa')) !== null)
  )

  realizaConsulta = (filtrosPesquisa) => {
    let filtrosConsulta = {};

    const existeFiltroPesquisaUtilizado =
      this.verificarSeFiltroPesquisaExiste();

    if (!filtrosPesquisa && existeFiltroPesquisaUtilizado) {
      filtrosConsulta = this.montaFiltros(JSON.parse(sessionStorage.getItem('filtroPesquisa')));
    } else if (filtrosPesquisa) {
      filtrosConsulta = this.montaFiltros(filtrosPesquisa);
    }

    const atributosConsulta = this.verificaAtributosParaConsulta();

    if (atributosConsulta) {
      if (filtrosConsulta.estado === undefined) {
        filtrosConsulta.estado = atributosConsulta.estados;
      }

      filtrosConsulta.participacao = atributosConsulta.tipoParticipacao;

      filtrosConsulta['atributo-ordenacao'] = atributosConsulta.campoOrdenacao;

      if (atributosConsulta.filtroTipoExigencias) {
        filtrosConsulta['tipo-exigencia'] = atributosConsulta.filtroTipoExigencias;
      }

      if (atributosConsulta.tipoRequerimento) {
        filtrosConsulta['tipo-requerimento'] = atributosConsulta.tipoRequerimento;
      }

      if (atributosConsulta.estado) {
        filtrosConsulta.estado = atributosConsulta.estado;
      }
    }

    // quando clicar em pesquisar, volta para primeira página
    const novaPagina = filtrosPesquisa && filtrosPesquisa.cliqueiNoBotao === 1
      ? 1
      : this.state.estadoTabela.paginaAtual;

    this.setState(prevState => ({
      filtrosConsulta,
      estadoTabela: {
        ...prevState.estadoTabela,
        paginaAtual: novaPagina,
      },
    }), this.executaConsulta);
  };

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length === 0) {
      this.setState({
        listaRequerimentosIndexada: [],
        listaRequerimentosIndexadaAtualizada: true,
      });

      return;
    }

    const {
      paginaAtual,
      resultadosPorPagina,
    } = this.state.estadoTabela;

    const primeiroItem =
      (paginaAtual - 1) * resultadosPorPagina;

    const paramsBase = {
      ...this.state.filtrosConsulta,
      'unidade-inss': this.lotacao,
      'start-position': primeiroItem,
      'max-results': resultadosPorPagina,
    };

    if (
      this.props.auth.checkPermission([
        'requerer-compensacao-rgps',
        'analisar-compensacao-rgps',
      ])
    ) {
      doGet(
        'requerimentos-compensacao',
        this.tratarSucesso,
        this.tratarErro,
        paramsBase,
      );

      return;
    }

    let url = 'requerimentos-compensacao/destinatario-rpps';

    let params = {
      ...paramsBase,
    };

    if (
      this.props.match.params.tipoConsulta === 'analise'
      || this.props.match.params.tipoConsulta === 'complementar-aposentadoria'
    ) {
      params = {
        ...params,
        'participacao-solicitante':
          { rgps: 1, rpps: 2 }[
            this.props.match.params.regime
          ],
      };
    }

    if (
      this.props.match.params.tipoConsulta
        === 'complementar-aposentadoria'
    ) {
      url =
        'requerimentos-compensacao-aposentadoria/complementar-aposentadoria';
    }

    doGet(
      url,
      this.tratarSucesso,
      this.tratarErro,
      params,
    );
  };

  montaFiltros = (atributosPesquisa) => {
    let atributos = {
      participacao: atributosPesquisa.participacao,
      'unidade-inss': this.lotacao,
    };

    if (atributosPesquisa.cpf) {
      atributos = {
        ...atributos,
        cpf: atributosPesquisa.cpf,
      };
    }

    if (atributosPesquisa.tipoRequerimento) {
      atributos = {
        ...atributos,
        'tipo-requerimento': atributosPesquisa.tipoRequerimento,
      };
    }

    if (atributosPesquisa['destinatario-rpps']) {
      atributos = {
        ...atributos,
        'destinatario-rpps':
          atributosPesquisa['destinatario-rpps'],
      };
    }

    if (atributosPesquisa.estado) {
      atributos = {
        ...atributos,
        estado: atributosPesquisa.estado,
      };
    }

    if (atributosPesquisa.motivo) {
      atributos = {
        ...atributos,
        motivo: atributosPesquisa.motivo,
      };
    }

    return atributos;
  };

  verificaAtributosParaConsulta = () => {
    if (this.getTipoConsulta()) {
      return constantes.estadosParaConsulta[this.getTipoConsulta()];
    }
    return null;
  }

  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '') {
      this.setState({
        showNoContent: false,
        listaRequerimentosIndexada: [],
        listaRequerimentosIndexadaAtualizada: true,
        estadoTabela,
      });
    } else {
      this.setState({
        showNoContent: false,
        listaRequerimentosIndexada: [...response.data],
        listaRequerimentosIndexadaAtualizada: true,
        estadoTabela,
      });
    }
  };

  /**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */
  tratarFiltroNaLista = (listaRequerimentosFiltrada) => {
    this.setState({ listaRequerimentosFiltrada, listaRequerimentosIndexadaAtualizada: false });
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: 'Requerimento não encontrado para o protocolo informado.',
            noContentSecondaryMessage: 'Informe um protocolo válido.',
          });
        } else {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: `${data.mensagem}`,
            noContentSecondaryMessage: `${data.descricao}`,
          });
        }
      } else {
        this.setState({
          showNoContent: true,
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleChange = (e, name) => {
    this.setState({
      ...this.state,
      [name]: e,
    });
  }

  handleModal = (modal) => {
    this.setState({ [modal]: !this.state[modal] });
  }

  exibirModalAlerta = (paramDescricao, requerimento, chaveConfirmacao) => {
    const alertas = [{ descricao: paramDescricao }];
    this.setState({
      showModalAlertaRequerPerConcomitancia: true,
      alertas,
      requerimento,
      chaveConfirmacao,
    });
  }

  handleModalComposto = (modal, descricao, requerimento, chaveConfirmacao) => {
    this.setState({ [modal]: !this.state[modal] }, this.exibirModalAlerta(descricao, requerimento, chaveConfirmacao));
  }

  handleResponseUploadDocumento = (response) => {
    if (response.data.exigencias && response.data.exigencias.length > 0) {
      const possuiExigenciaDocumento = response.data.exigencias
        .filter(exigencia => exigencia.tipoDocumento)
        .length > 0;
      if (possuiExigenciaDocumento) {
        this.setState({
          requerimentoModalDocumento: response.data,
        }, () => this.handleModal('showDocumentUploadModal'));
      } else {
        this.realizaConsulta();
        trataMensagensErro(['A exigência de documento aberta para este requerimento já foi atendida. A lista será atualizada.']);
      }
    } else {
      this.realizaConsulta();
      trataMensagensErro(['A exigência de documento aberta para este requerimento já foi atendida. A lista será atualizada.']);
    }
  }

  showDocumentUploadModal = (requerimento) => {
    this.setState({
      // exigenciaModalDocumento: exigencia,
      requerimentoModalDocumento: requerimento,
    });

    let tipo = 'pensao';
    if (requerimento.tipoRequerimento === 1) {
      tipo = 'aposentadoria';
    }
    doGet(
      `requerimentos-compensacao-${tipo}/${requerimento.protocolo}`,
      this.handleResponseUploadDocumento,
      this.handleErrorEncerramentoExigencia,
    );
  }

  showTratamentoExigenciaVerificacaoRequerimento = (requerimento, acaoExigencia) => {
    let tipo = 'pensao';
    let metodoSucesso = this.handleResponseCumprimentoExigencia;
    if (requerimento.tipoRequerimento === 1) {
      tipo = 'aposentadoria';
    }
    if (acaoExigencia === 'encerrar') {
      metodoSucesso = this.handleResponseEncerramentoExigencia;
    }
    if (acaoExigencia === 'qualificar') {
      metodoSucesso = this.handleResponseQualificacaoRequerimento;
    }
    doGet(
      `requerimentos-compensacao-${tipo}/${requerimento.protocolo}`,
      metodoSucesso,
      this.handleErrorEncerramentoExigencia,
    );
  }

  handleResponseQualificacaoRequerimento = (response) => {
    let tipo = 'pensao';
    if (response.data.tipoAposentadoria) {
      tipo = 'aposentadoria';
    }
    if (response.data.exigencias && response.data.exigencias.length > 0) {
      const possuiExigenciaQualificacao = response.data.exigencias
        .filter(exigencia => (exigencia.tipo === 72))
        .length > 0;
      if (possuiExigenciaQualificacao) {
        this.props.history.push(`/requerimento/${tipo}/${response.data.protocolo}/qualificar`);
      } else {
        this.realizaConsulta();
        trataMensagensErro(['A solicitação de qualificação aberta para este requerimento já foi atendida. A lista será atualizada.']);
      }
    } else {
      this.realizaConsulta();
      trataMensagensErro(['A solicitação de qualificação aberta para este requerimento já foi atendida. A lista será atualizada.']);
    }
  }

  showRejeicaoRequerimento = (requerimento) => {
    const tipo = this.diffRequerimento(requerimento.tipoRequerimento);
    this.setState({ tipoRequerimento: requerimento.tipoRequerimento });
    doGet(
      `requerimentos-compensacao-${tipo}/${requerimento.protocolo}`,
      this.handleResponseRejeicaoRequerimento,
      this.handleErrorEncerramentoExigencia,
    );
  }

  handleResponseCumprimentoExigencia = (response) => {
    let tipo = 'pensao';
    if (response.data.tipoAposentadoria) {
      tipo = 'aposentadoria';
    }
    if (response.data.exigencias && response.data.exigencias.length > 0) {
      this.props.history.push(`/requerimento/${tipo}/${response.data.protocolo}/cumprir-exigencia`);
    } else {
      this.realizaConsulta();
      trataMensagensErro(['As exigências de alteração abertas para este requerimento já foram atendidas. A lista será atualizada.']);
    }
  }

  handleResponseEncerramentoExigencia = (response) => {
    if (response.data.exigencias && response.data.exigencias.length > 0) {
      const possuiExigenciaAtributo = response.data.exigencias
        .filter(exigencia => (!constantes.tiposExigenciaSistema.includes(exigencia.tipo)))
        .length > 0;
      if (possuiExigenciaAtributo) {
        this.setState({
          requerimentoModalExigencia: response.data,
        }, () => this.handleModal('showEncerramentoExigenciaModal'));
      } else {
        this.realizaConsulta();
        trataMensagensErro(['As exigências de alteração abertas para este requerimento já foram atendidas. A lista será atualizada.']);
      }
    } else {
      this.realizaConsulta();
      trataMensagensErro(['As exigências de alteração abertas para este requerimento já foram atendidas. A lista será atualizada.']);
    }
  }

  handleResponseRejeicaoRequerimento = (response) => {
    this.setState({
      requerimentoModalExigencia: response.data,
    }, () => this.handleModal('showRejeicaoRequerimentoModal'));
  }

  handleErrorEncerramentoExigencia = () => {
  }

  handleDocumentSent = (location, tipoDocumento) => {
    const mensagemSucesso = ['Documento anexado ao requerimento com sucesso. Exigência encerrada.'];
    trataMensagemSucesso(mensagemSucesso);
    const { listaRequerimentosIndexada } = { ...this.state };
    const indexReq = listaRequerimentosIndexada
      .findIndex(req => (req.protocolo === this.state.requerimentoModalDocumento.protocolo));
    const indexExigencia = listaRequerimentosIndexada[indexReq].exigencias
      .findIndex(exi => (exi.tipoDocumento === tipoDocumento));

    listaRequerimentosIndexada[indexReq].exigencias.splice(indexExigencia, 1);
    if (listaRequerimentosIndexada[indexReq].exigencias.length === 0) {
      listaRequerimentosIndexada.splice(indexReq, 1);
    }
    this.realizaConsulta();
    this.setState({
      listaRequerimentosIndexada,
      listaRequerimentosIndexadaAtualizada: true,
    }, () => this.handleModal('showDocumentUploadModal'));
  }

  handleEncerramentoExigenciaSent = () => {
    const mensagemSucesso = ['Exigências não atendidas encerradas.'];
    trataMensagemSucesso(mensagemSucesso);
    const { listaRequerimentosIndexada } = { ...this.state };
    const indexReq = listaRequerimentosIndexada
      .findIndex(req => (req.protocolo === this.state.requerimentoModalExigencia.protocolo));
    listaRequerimentosIndexada.splice(indexReq, 1);
    this.setState({
      listaRequerimentosIndexada,
      listaRequerimentosIndexadaAtualizada: true,
    }, () => this.handleModal('showEncerramentoExigenciaModal'));
  }

  handleRejeicaoRequerimentoSent = () => {
    const mensagemSucesso = ['Requerimento Rejeitado.'];
    trataMensagemSucesso(mensagemSucesso);
    const { listaRequerimentosIndexada } = { ...this.state };
    this.realizaConsulta();
    this.setState({
      listaRequerimentosIndexada,
      listaRequerimentosIndexadaAtualizada: true,
    }, () => this.handleModal('showRejeicaoRequerimentoModal'));
  }

  montaAcoesExigencia = (row) => {
    const { exigencias } = { ...row };
    let acaoUploadDisponivel = false;
    let acaoEncerramentoDisponivel = false;
    let acaoRejeicaoDisponivel = false;
    let acaoQualificacaoDisponivel = false;
    let botoesDocumentos = null;
    if (exigencias) {
      botoesDocumentos = exigencias.map((exigencia) => {
        if (!acaoEncerramentoDisponivel && !constantes.tiposExigenciaSistema.includes(exigencia.tipo)) {
          acaoEncerramentoDisponivel = true;
        }

        if ((this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps',
          'requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'gerenciar-negocio-dcomp'])) &&
          !acaoRejeicaoDisponivel
          && (row.tipoRequerimento === 1 || row.tipoRequerimento === 2)) {
          acaoRejeicaoDisponivel = true;
        }

        if (exigencia.tipoDocumento && (!exigencia.atributo)) {
          acaoUploadDisponivel = true;
        }

        if (exigencia.tipo === 72) {
          acaoQualificacaoDisponivel = true;
        }

        return '';
      });
    }
    const botaoUpload = acaoUploadDisponivel ? (
      <Button
        hint="Carregar documento"
        icon="ico-upload"
        mini
        disabled={this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp}
        onClick={() => this.showDocumentUploadModal(row)}
      />
    ) : '';
    const botaoAlterar = (
      <Button
        hint="Alterar requerimento"
        icon="ico-doc-pencil"
        mini
        disabled={this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp}
        onClick={() => this.showTratamentoExigenciaVerificacaoRequerimento(row, 'cumprir')}
      />
    );
    const botaoQualificar = (acaoQualificacaoDisponivel
        && this.props.configuracoesFrontend
        && this.props.configuracoesFrontend.habilitarQualificacao) ? (
          <Button
            hint="Qualificar requerimento"
            icon="ico-doc-refresh"
            mini
            disabled={this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp}
            onClick={() => this.showTratamentoExigenciaVerificacaoRequerimento(row, 'qualificar')}
          />) : '';
    const botaoEncerrarExigencia = acaoEncerramentoDisponivel ? (
      <Button
        hint="Encerrar exigências do requerimento"
        icon="ico-doc-check"
        mini
        disabled={this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp}
        onClick={() => this.showTratamentoExigenciaVerificacaoRequerimento(row, 'encerrar')}
      />
    ) : null;
    const botaoCancelarRequerimento = acaoRejeicaoDisponivel ? (
      <Button
        hint="Rejeitar requerimento"
        icon="ico-trash-can"
        mini
        disabled={this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp}
        onClick={() => this.showRejeicaoRequerimento(row, 'cancelar')}
      />
    ) : '';
    return (
      <React.Fragment>
        { botaoQualificar }
        { botaoUpload }
        { botoesDocumentos }
        { botaoAlterar }
        { botaoEncerrarExigencia }
        { botaoCancelarRequerimento }
      </React.Fragment>
    );
  }

  pushNavegacao = (tipo, row) => {
    if (!this.getTipoConsulta()) {
      this.props.history.push(`/requerimento/${tipo}/${row.protocolo}`);
    } else {
      const atributosConsulta = this.verificaAtributosParaConsulta();
      if (tipo && row) {
        this.props.history.push(`/requerimento/${tipo}/${row.protocolo}/${atributosConsulta.acao}`);
      } else {
        this.props.history.push(`/requerimento/${this.state.tipoRequerimentoSelecionado}/${this.state.requerimentoVindoDoRequest.protocolo}/${atributosConsulta.acao}`);
      }
    }
  }

  handleClickNovoEstado = (row, tipo) => {
    this.setState({ tipoRequerimentoSelecionado: tipo });
    if (row.estado === 6 || row.estado === 7 || !this.getTipoConsulta()) {
      this.pushNavegacao(tipo, row);
    } else if ((this.getTipoConsulta() === 'complementar-aposentadoria' && row.estado === 4)) {
      this.pushNavegacao(tipo, row);
    } else {
      doGet(
        `requerimentos-compensacao-${tipo}/${row.protocolo}`,
        this.handleGetNovoEstadoSuccess,
        this.handleClickNovoEstadoFail,
      );
    }
  }

  handleGetNovoEstadoSuccess = (response) => {
    const requerimentoVindoDoRequest = response.data;
    this.setState({ requerimentoVindoDoRequest });

    if (requerimentoVindoDoRequest.estado !== 4
      && requerimentoVindoDoRequest.estado !== 10 && requerimentoVindoDoRequest.estado !== 5) {
      this.realizaConsulta();
      trataMensagensErro(['Este requerimento já está sendo analisado por outro usuário. A lista será atualizada.']);
    } else {
      // Alteracao de estado para atualizacao de requerimento
      if (requerimentoVindoDoRequest.estado === 4 || requerimentoVindoDoRequest.estado === 10) {
        requerimentoVindoDoRequest.estado = 6;
      } else if (requerimentoVindoDoRequest.estado === 5) {
        requerimentoVindoDoRequest.estado = 7;
      }
      // Request
      doPut(
        `requerimentos-compensacao-${this.state.tipoRequerimentoSelecionado}/${requerimentoVindoDoRequest.protocolo}`,
        requerimentoVindoDoRequest,
        this.handleClickNovoEstadoSuccess,
        this.handleClickNovoEstadoFail,
        {
          codigo: 3019,
          mensagem: 'Este requerimento já está sendo analisado por outro usuário. A lista será atualizada.',
        },
      );
    }
  }

  handleClickNovoEstadoSuccess = () => {
    this.pushNavegacao(this.state.requerimentoVindoDoRequest);
  }

  handleClickNovoEstadoFail = () => {
    this.realizaConsulta();
  }

    diffRequerimento = (tipoRequerimento) => {
      if (tipoRequerimento === 2) {
        return 'pensao';
      }
      return 'aposentadoria';
    }

  montaAcoesAnalise = (row, tipo) => (
    <Button
      hint="Analisar requerimento"
      icon="ico-doc-magnifier"
      mini
      disabled={this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp}
      onClick={() => this.handleClickNovoEstado(row, tipo)}
    />
  );

  montaAcoesConsulta = (row, tipo) => (
    <Button
      hint="Consultar requerimento"
      icon="ico-doc-magnifier"
      mini
      onClick={() => this.handleClickNovoEstado(row, tipo)}
    />
  );

  montaAcoesComplementarAposentadoria = (row, tipo) => (
    <Button
      hint="Complementar aposentadoria"
      icon="ico-doc-pencil"
      mini
      onClick={() => this.handleClickNovoEstado(row, tipo)}
    />
  );

  createActionColumn = (cell, row) => {
    let tipo = 'pensao';
    if (row.tipoRequerimento === 1) {
      tipo = 'aposentadoria';
    }
    let acoes = '';
    switch (this.getTipoConsulta()) {
      case 'exigencia':
        acoes = this.montaAcoesExigencia(row, tipo);
        break;
      case 'prescricao-exigencia':
        acoes = this.montaAcoesExigencia(row, tipo);
        break;
      case 'analise':
        acoes = this.montaAcoesAnalise(row, tipo);
        break;
      case 'parecer-medico':
        acoes = this.montaAcoesAnalise(row, tipo);
        break;
      default:
        if (this.props.match.params.tipoConsulta === 'complementar-aposentadoria') {
          acoes = this.montaAcoesComplementarAposentadoria(row, tipo);
        } else {
          acoes = this.montaAcoesConsulta(row, tipo);
        }
        break;
    }
    return acoes;
  };

  addTipoRequerimentoLabel = tipo => (
    listUtils.getObject(listUtils.tipoRequerimento, tipo).label
  )

  addTipoEstadoLabel = (tipo) => {
    if (tipo === 15) {
      return 'Exigência/indeferido';
    }

    if (tipo === 16) {
      return 'Indeferimento ratificado';
    }

    if (tipo === undefined || tipo === null) {
      return '';
    }

    return listUtils.getObject(listUtils.tiposEstado, tipo).label;
  }

  colunasDefault = [{
    id: 'cpf',
    label: 'CPF',
  }, {
    id: 'nome',
    label: 'Nome',
  }, {
    id: 'matricula',
    label: 'Matrícula',
  }, {
    id: 'nomeSolicitante',
    label: 'Solicitante',
  }, {
    id: 'nomeDestinatario',
    label: 'Destinatário',
  }, {
    id: 'tipoRequerimento',
    label: 'Tipo',
    dataFormat: this.addTipoRequerimentoLabel,
  }];

  montaColunasEspecificas = () => {
    switch (this.getTipoConsulta()) {
      case 'analise':
        if (this.props.auth.checkPermission(['requerer-compensacao-rpps'])) {
          return [{
            id: 'qtdDiasEstadoAguardandoAnalise',
            label: 'Dias no Estado',
          }, {
            id: 'estado',
            label: 'Estado',
            dataFormat: this.addTipoEstadoLabel,
          }];
        }
        return [
          {
            id: 'estado',
            label: 'Estado',
            dataFormat: this.addTipoEstadoLabel,
          }];
      case 'exigencia':
        return [{
          id: 'prazoAtendimentoExigencias',
          label: 'Prazo (em dias)',
        }];
      case 'parecer-medico':
        return [{
          id: 'estado',
          label: 'Estado',
          dataFormat: this.addTipoEstadoLabel,
        }];
      case 'prescricao-exigencia':
        return this.montaColunasEspecificasExigencias();
      case 'complementar-aposentadoria':
        if (this.props.auth.checkPermission(['requerer-compensacao-rpps'])) {
          return [{
            id: 'qtdDiasEstadoAguardandoAnalise',
            label: 'Dias no Estado',
          }, {
            id: 'estado',
            label: 'Estado',
            dataFormat: this.addTipoEstadoLabel,
          }];
        }
        return [
          {
            id: 'estado',
            label: 'Estado',
            dataFormat: this.addTipoEstadoLabel,
          }];
      default:
        return [{
          id: 'estado',
          label: 'Estado',
          dataFormat: this.addTipoEstadoLabel,
        }];
    }
  };

  montaColunasEspecificasExigencias = () => {
    if (this.props.auth.checkPermission(['requerer-compensacao-rgps'])) {
      return [{
        id: 'dataCreditoPagamento',
        label: 'Data de Crédito do Pagamento',
      }];
    }
    return [{
      id: 'dataHomologacaoTribunalContas',
      label: 'Data de Homologação no Tribunal de Contas',
    }];
  };

  montaColunas = () => {
    let requerimentosExigenciaTableHeader = this.colunasDefault.slice();
    const colunasEspecificas = this.montaColunasEspecificas();
    if (colunasEspecificas) {
      requerimentosExigenciaTableHeader = requerimentosExigenciaTableHeader
        .concat(colunasEspecificas);
    }
    // if (!this.props.auth.checkPermission(['gerenciar-negocio-inss'])) {
    requerimentosExigenciaTableHeader.push({
      id: 'acoes',
      label: 'Ações',
      dataFormat: this.createActionColumn,
    });
    // }
    return requerimentosExigenciaTableHeader;
  }

  montaTituloTabela = () => {
    switch (this.getTipoConsulta()) {
      case 'analise':
        return 'Requerimentos Aguardando Análise, Em Análise ou Com Análise Suspensa';
      case 'exigencia':
        return 'Requerimentos em Exigência';
      case 'parecer-medico':
        return 'Requerimentos Aguardando Parecer do Médico';
      case 'prescricao-exigencia':
        return 'Requerimentos em Exigência (Prescrição)';
      case 'complementar-aposentadoria':
        return 'Requerimentos em Análise a serem Complementados';
      default:
        return 'Requerimentos';
    }
  }

  defineListaParaTabela = () => {
    if (this.state.listaRequerimentosFiltrada !== null) {
      return this.state.listaRequerimentosFiltrada;
    }
    return this.state.listaRequerimentosIndexada;
  }

  alterarPagina = (pagina, resultadosPorPagina) => {
    this.setState(prevState => ({
      estadoTabela: {
        ...prevState.estadoTabela,
        paginaAtual: pagina === 0 ? 1 : pagina,
        resultadosPorPagina:
          resultadosPorPagina
          || prevState.estadoTabela.resultadosPorPagina,
      },
    }), this.executaConsulta);
  };

  alterarResultadosPorPagina = (resultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.resultadosPorPagina = resultadosPorPagina;
    this.setState(
      { estadoTabela },
      this.realizaConsulta,
    );
  }

  trataSucessoResponseEnvio = () => {
    const mensagemSucesso = ['Exigências não atendidas encerradas.'];
    trataMensagemSucesso(mensagemSucesso);
    const { listaRequerimentosIndexada } = { ...this.state };
    const indexReq = listaRequerimentosIndexada
      .findIndex(req => (req.protocolo === this.state.requerimentoModalExigencia.protocolo));
    listaRequerimentosIndexada.splice(indexReq, 1);
    this.setState({
      listaRequerimentosIndexada,
      listaRequerimentosIndexadaAtualizada: true,
    }, () => this.handleModal('showModalAlertaRequerPerConcomitancia'));
  }

  trataErrosResponse = (error) => {
    // eslint-disable-next-line
    console.log(error);
    // trataMensagensErro(['DEU RUIM.']);
    this.handleModal('showModalAlertaRequerPerConcomitancia');
  }

  handleSaveEncerramentoExigencia = () => {
    const { requerimento } = { ...this.state };
    requerimento.estado = 3;

    let url = `requerimentos-compensacao-pensao/${requerimento.protocolo}`;
    if (requerimento.tipoAposentadoria) {
      url = `requerimentos-compensacao-aposentadoria/${requerimento.protocolo}`;
    }

    let options;
    if (this.state.chaveConfirmacao) {
      options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
    }
    doPut(
      url,
      requerimento,
      this.trataSucessoResponseEnvio,
      this.trataErrosResponse,
      {
        codigo: 3019,
        mensagem: 'Não foi possível alterar o estado do requerimento.',
      },
      options,
    );
  }

  render() {
    const options = {
      noDataText: 'Nenhum requerimento a ser exibido',
      hideSizePerPage: false,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
      sizePerPageList: listUtils.linhasPorPagina,
      // alwaysShowAllBtns: false,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };
    const requerimentosExigenciaTableHeader = this.montaColunas();

    let modalEncerramentoExigencia = '';
    if (this.state.showEncerramentoExigenciaModal) {
      modalEncerramentoExigencia = (
        <ModalEncerramentoExigencia
          {...this.props}
          requerimento={this.state.requerimentoModalExigencia}
          handleEncerramentoExigenciaSent={this.handleEncerramentoExigenciaSent}
          handleModal={() => this.handleModal('showEncerramentoExigenciaModal')}
          handleModalComposto={this.handleModalComposto}
        />
      );
    }
    let modalRejeicaoRequerimento = '';
    if (this.state.showRejeicaoRequerimentoModal) {
      modalRejeicaoRequerimento = (
        <ModalRejeicaoRequerimento
          {...this.props}
          requerimento={this.state.requerimentoModalExigencia}
          tipoRequerimento={this.state.tipoRequerimento}
          handleRejeicaoRequerimentoSent={this.handleRejeicaoRequerimentoSent}
          handleModal={() => this.handleModal('showRejeicaoRequerimentoModal')}
        />
      );
    }
    let modalAlertaRequerPerConcomitancia = '';
    if (this.state.showModalAlertaRequerPerConcomitancia) {
      modalAlertaRequerPerConcomitancia = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.handleSaveEncerramentoExigencia}
        handleModal={() => this.handleModal('showModalAlertaRequerPerConcomitancia')}
        labelTitulo="Salvar requerimento com períodos concomitantes ?"
        labelBotaoConfirmarAcao="sim"
        labelBotaoCancelarAcao="não"
        showModal
      />);
    }
    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <FiltroPesquisa
            handleSearchFilter={this.realizaConsulta}
            handleChangeList={this.tratarFiltroNaLista}
            destinatarios={this.props.destinatarios}
            list={this.state.listaRequerimentosIndexada}
            tipoConsulta={this.getTipoConsulta()}
            listaRequerimentosIndexadaAtualizada={this.state.listaRequerimentosIndexadaAtualizada}
            auth={this.props.auth}
          />
          <Table
            key={`${this.state.estadoTabela.paginaAtual} - ${this.state.estadoTabela.quantidadeTotalResultados}`}
            legend={this.montaTituloTabela()}
            bordered
            fetchInfo={fetchInfo}
            data={this.defineListaParaTabela()}
            options={options}
            listaTableHeader={requerimentosExigenciaTableHeader}
            pagination
            remote
          />
          {this.state.showDocumentUploadModal ? (
            <ModalUploadDocumento
              {...this.props}
              requerimento={this.state.requerimentoModalDocumento}
              handleDocumentSent={this.handleDocumentSent}
              // handleFailDocumentSent={this.realizaConsulta}
              handleModal={() => this.handleModal('showDocumentUploadModal')}
              showModal={this.state.showDocumentUploadModal}
            />
          ) : ''}
          {modalEncerramentoExigencia}
          {modalRejeicaoRequerimento}
          {modalAlertaRequerPerConcomitancia}
        </DtpContentContainer>
      )
    );
  }
}

ConsultaExigencia.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      tipoConsulta: PropTypes.string,
      regime: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
  exigencias: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  configuracoesFrontend: PropTypes.arrayOf(PropTypes.string).isRequired,
};

ConsultaExigencia.defaultProps = {
  destinatarios: [],
  match: null,
  exigencias: [],
};

const mapStateToProps = state => ({
  configuracoesFrontend: state.base.configuracoesFrontend,
  destinatarios: state.base.destinatarios,
  exigencias: state.base.exigencias,
});

export default connect(mapStateToProps)(ConsultaExigencia);



// WEBPACK FOOTER //
// ./src/pages/consultas/Consulta.jsx